module.exports = __webpack_public_path__ + "img/20200609_114030.59120468.jpg";